import { render, staticRenderFns } from "./index_mobile.vue?vue&type=template&id=232f2e12&scoped=true&"
import script from "./index_mobile.vue?vue&type=script&lang=js&"
export * from "./index_mobile.vue?vue&type=script&lang=js&"
import style0 from "./index_mobile.vue?vue&type=style&index=0&id=232f2e12&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "232f2e12",
  null
  
)

export default component.exports